import Home from './Home.component';

export default Home;
